var React = require('react');

function Fr (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#002654","d":"M0 0h213.3v480H0z","key":1}),React.createElement("path",{"fill":"#ce1126","d":"M426.7 0H640v480H426.7z","key":2})]));
}

Fr.defaultProps = {"id":"flag-icons-fr","viewBox":"0 0 640 480"};

module.exports = Fr;

Fr.default = Fr;
